import { portalBaseUrl, dadosCadastraisUrl } from "@/globals";
import { api } from "roboflex-thalamus-request-handler";
import { sso } from "roboflex-thalamus-sso-lib";

const moduloService = {
  /**
   * Usa a baseURL já configurada pelo app consumidor (VUE_APP_ROOT_API via request-handler).
   */
  buscarModulos: async () => {
    const usuarioLogado = sso.getUsuarioLogado();
    if (!usuarioLogado || usuarioLogado.id == null) {
      throw new Error("Usuário ainda não carregado");
    }

    const response = await api.post("funcionalidade/cards/usuario", {
      usuario_id: usuarioLogado.id,
    });

    return response.data;
  },

  linkPortal(buildMode) {
    return portalBaseUrl(buildMode);
  },

  linkDadosCadastrais(buildMode) {
    return dadosCadastraisUrl(buildMode);
  },

  getPessoa: async () => {
    const response = await api.get("pessoa/usuario");
    return response.data;
  },
};

export default moduloService;
